import React from "react";
import classNames from "classnames";
import moment from "moment";
import PaymentDetails from "./../../components/bulk/paymentDetails.jsx";
import Loading from "./../../components/popups/loading.jsx";
import { currencyFormatter } from "../../utils/display";

export default ({
  id,
  amount,
  status,
  payment,
  activePanel,
  chooseActivePanel,
  showLocalSpinner,
}) => {
  const panelIconClasses = classNames({
    "fa fa-angle-up fa-lg": activePanel === id,
    "fa fa-angle-down fa-lg": activePanel !== id,
  });

  const panelClasses = classNames(
    "flex-column",
    "panel-border",
    "add-margin-sm-screen",
    {
      "active-panel-material": activePanel === id,
      "mar-t-20": activePanel === id,
      "mar-b-20": activePanel === id,
    }
  );

  const responsivePanelClasses = classNames(
    "responsive-panel-table",
    "fixed-table",
    "pointer",
    {
      "remove-border-btm-mobile": activePanel === id,
    }
  );

  const ShowSpinner = () => {
    if (showLocalSpinner && activePanel === id) {
      return <div id="localLoader"></div>;
    }
    return null;
  };

  const PayoutAmountClassName =
    amount > 0 ? "positiveNumber" : "negativeNumber";

  return (
    <div className={panelClasses}>
      <table
        className={responsivePanelClasses}
        onClick={chooseActivePanel.bind(null, id)}
      >
        <tbody>
          <tr>
            <td className="panel-column">
              <div className="responsive-panel flex-column">
                <span className="hide-lg acct-txt-12">
                  <span>Payment ID: </span>
                </span>
                <span className="acct-blue-label pad-r-5 ft-bold">#{id}</span>
              </div>
            </td>
            <td className="panel-column">
              <div className="responsive-panel flex-column">
                <span className="acct-txt-12 hide-lg">
                  <span>Payout Amount: </span>
                </span>
                <span className="acct-txt-12 ft-bold">
                  <span className={PayoutAmountClassName}>
                    {currencyFormatter(amount)}
                  </span>
                </span>
              </div>
            </td>
            <td className="panel-column">
              <div className="responsive-panel flex-column">
                <span className="acct-txt-12 hide-lg">
                  <span>Status: </span>
                </span>
                <span className="acct-txt-12 ft-bold">{status}</span>
              </div>
            </td>
            <td className="panel-column-sm hide-sm">
              <i className={panelIconClasses}></i>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        onClick={chooseActivePanel.bind(null, id)}
        className="panel-details-heading hide-lg"
      >
        <div>Payment Details</div>
        <i
          className={
            activePanel === id
              ? "fa fa-angle-up fa-lg ft-bold"
              : "fa fa-angle-down fa-lg ft-bold"
          }
        />
      </div>
      {activePanel === id && Object.keys(payment).length ? (
        <PaymentDetails activePanel={activePanel} id={id} payment={payment} />
      ) : (
        <ShowSpinner />
      )}
    </div>
  );
};
